<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1><br/><br/><br/>
<p>Felix Warnock spent fifteen years as a freelance bassoon player based in London, but frequently on tour around the world. He was a founder member of the Orchestra of the Age of Enlightenment, becoming its chief executive in 1988. He spent a further fifteen years as manager of The English Concert. He taught bassoon at Trinity College of Music, was briefly Head of Early Music at the Royal Academy of Music and was chairman of The Radcliffe Trust until 2019. He lives in London and now works in mental health research, a field in which he is eminently qualified after a career in the orchestral world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2a030743